import React, { FC } from 'react'
import './Login2FAForm.scss'
import RegisterWrapperCard from 'app_components/screens/register/components/RegisterWrapperCard/RegisterWrapperCard'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { useForm } from 'react-hook-form'
import FormTextField from 'app_components/commons/FormTextField/FormTextField'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'

interface ILogin2FAFormProps {
  onSubmit: (code: string) => void
  onGoBack: () => void
  loading?: boolean
}

const Login2FAForm: FC<ILogin2FAFormProps> = ({ onSubmit, onGoBack, loading }) => {
  const { control, errors, handleSubmit } = useForm()

  const handleSubmitForm = (params: {code: string}) => {
    onSubmit(params.code)
  }

  return (
    <RegisterWrapperCard title='Doble factor de autenticación'>
      <form onSubmit={handleSubmit(handleSubmitForm)} className="login-2fa-form--layout">
        <TextComponent>Hemos enviado un código a tu correo electrónico para validar tu identidad.</TextComponent>
        <FormTextField
          id='code'
          label="Código"
          control={control}
          required
          error={errors?.code}
          errorText="Este campo es requerido"
        />
        <div className="login-2fa-form--actions">
          <ButtonComponent
            border='1px solid var(--secondary)'
            color='var(--secondary)'
            textTransform='initial'
            paddingTop={11}
            paddingBottom={11}
            fontSize={18}
            type='button'
            width='100%'
            onClick={onGoBack}
            disabled={loading}
          >
            Cancelar
          </ButtonComponent>
          <ButtonComponent
            variant='secondary'
            textTransform='initial'
            paddingTop={12}
            paddingBottom={12}
            fontSize={18}
            type="submit"
            width='100%'
            loading={loading}
          >
            Ingresar
          </ButtonComponent>
        </div>
      </form>
    </RegisterWrapperCard>
  )
}

export default Login2FAForm
